import React from 'react';
import { Box, BoxProps, Button, Typography } from '@material-ui/core';
// import InfoIcon from '@material-ui/icons/Info';

type Props = {
  setList: Array<{ name: string; id: number }>;
  title: string;
  containerProps?: BoxProps;
  handleClick?: (id: number) => void;
  selected?: number;
};

const PrmTitleRow: React.FC<Props> = ({
  setList,
  title,
  containerProps,
  handleClick,
  selected
}) => {
  return (
    <Box
      display="flex"
      flex={1}
      justifyContent="space-between"
      style={{ flexFlow: 'wrap' }}
      {...containerProps}
    >
      <Typography variant="h3">
        {title}
        {/* <InfoIcon className={classes.infoIcon} /> */}
      </Typography>
      <Box display="flex">
        {// eslint-disable-next-line react/display-name
        setList?.map((x, idx) => (
          <Box padding={1} key={idx}>
            <TitleButton
              selected={selected === x.id}
              handleClick={() => handleClick?.(x.id)}
              name={x.name}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export const TitleButton: React.FC<{ selected: boolean; handleClick: any; name: string }> = ({
  selected,
  handleClick,
  name
}) => (
  <Button
    style={{
      borderRadius: 4,
      ...(selected ? { borderBottom: '4px solid #000' } : { textDecoration: 'underline' })
    }}
    variant="outlined"
    onClick={handleClick}
  >
    {name}
  </Button>
);

export default PrmTitleRow;
